export {version as default} from '../package.json';



//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/version.js
// module id = 273
// module chunks = 0